export enum EntityProjection {
    dataTable = 'dataTable',
    form = 'form',
    select = 'select',
    selectTable = 'select-table',
    center = 'center',
    // this is used for notfication
    update = 'update',
}
